<template>
  <div class="">
    <StepHeader
      :title="title"
      :theme="theme"
    />

    <StepContent :theme="theme">
      <AppInputWithValidation
        v-for="(field, index) in fields"
        :key="index"
        :label="field.label"
        :placeholder="field.placeholder"
        :name="field.name"
        :type="field.type"
        :field-name="field.name"
        :value="field.value"
        :rules="field.rules"
        :split="field.split"
        :hide-error="!submitted"
        :error="field.error"
        :max-length="field.maxLength"
        :theme="theme"
        @input="handleInput(field.vuexAction, $event)"
      />
    </StepContent>

    <StepFooter hide-mobile>
      <AppButton
        :theme="theme"
        :loading="submitting"
        @click="handleContinue()"
      >
        Continue
      </AppButton>
    </StepFooter>
  </div>
</template>

<script>
import AppButton from '@/components/common/buttons/AppButton'
import AppInputWithValidation from '@/components/common/inputs/AppInputWithValidation'
import StepContent from '@/components/common/step-layout/StepContent'
import StepFooter from '@/components/common/step-layout/StepFooter'
import StepHeader from '@/components/common/step-layout/StepHeader'
import navigation from '@/mixins/navigation'
import input from '@/mixins/input'
import submitLoans from '@/mixins/submit/submit-loans'

export default {
  // Name
  name: 'IncomeDuration',

  // Components
  components: {
    AppButton,
    AppInputWithValidation,
    StepContent,
    StepFooter,
    StepHeader
  },

  // Mixins
  mixins: [
    input,
    submitLoans,
    navigation
  ],

  // Props
  props: {
    title: {
      type: String,
      default: 'How Long Have You Been\nReceiving This Income?'
    },

    theme: {
      type: String,
      default: 'blue'
    }
  },

  // Computed
  computed: {
    employerYears () {
      return this.$store.state.employment.employer_years
    },

    employerMonths () {
      return this.$store.state.employment.employer_months
    },

    employerYearsError () {
      return this.$store.state.validations.employerYearsError
    },

    employerMonthsError () {
      return this.$store.state.validations.employerMonthsError
    },

    fields () {
      return [{
        label: 'Years',
        placeholder: '0',
        name: 'employer_years',
        type: 'tel',
        value: this.employerYears,
        rules: 'numeric|max_value:99|requiredYears:employer_months',
        split: true,
        error: this.employerYearsError,
        maxLength: 2,
        vuexAction: 'setEmployerYears'
      }, {
        label: 'Months',
        placeholder: '0',
        name: 'employer_months',
        type: 'tel',
        value: this.employerMonths,
        rules: 'numeric|max_value:11|requiredMonths:employer_years,started your new job',
        split: true,
        error: this.employerMonthsError,
        maxLength: 2,
        vuexAction: 'setEmployerMonths'
      }]
    },

    dataLayerObject () {
      return {
        event: `spring_${this.eventPrefix}_income_duration_continue`,
        income_duration: `${this.employerYears}y ${this.employerMonths}m`
      }
    },

    updateLeadPayload () {
      return {
        // Ensures values like "03" become "3" and "00" becomes "0".
        employer_years: isNaN(parseInt(this.employerYears?.trim(), 10)) ? '0' : parseInt(this.employerYears.trim(), 10).toString(),
        employer_months: isNaN(parseInt(this.employerMonths?.trim(), 10)) ? '0' : parseInt(this.employerMonths.trim(), 10).toString()
      }
    }
  },

  // Watch
  watch: {
    $_navigation_triggerContinue: async function (val) {
      if (val) await this.handleContinue()
      this.$store.dispatch('setTriggerContinue', false)
    }
  },

  methods: {
    async handleContinue () {
      this.submitted = true
      const isValid = await this.$_navigation_validateStep()
      if (isValid) {
        this.$_loans_updateLead(this.updateLeadPayload, this.dataLayerObject)
      }
    },
    handleInput (vuexAction, value) {
      this.$_input_updateState(vuexAction, value)
      if (this.submitted) {
        this.$_navigation_validateStep()
      }
    }
  }

}
</script>

<style scoped lang="scss">
</style>
